export default {
    manage_createEditAsset_label: "Label",
    manage_createEditAsset_assetType: "Type",
    manage_createEditAsset_assetSubtype: "SubType",
    manage_createEditAsset_licensePlate: "License Plate",
    manage_createEditAsset_registrationCountry: "Registration Country",
    manage_createEditAsset_registrationState: "Registration State",
    manage_createEditAsset_registrationExpiration: "Registration Expiration Date",
    manage_createEditAsset_vin: "VIN",
    manage_createEditAsset_make: "Make",
    manage_createEditAsset_model: "Model",
    manage_createEditAsset_year: "Year",
    manage_createEditAsset_engineLiters: "Engine Liters",
    manage_createEditAsset_highway: "Highway",
    manage_createEditAsset_city: "City",
    manage_createEditAsset_inspectionTagId: "Inspection Tag ID",
    manage_createEditAsset_asset: "Asset",
    manage_createEditAsset_tags: "Tags",
    manage_createEditAsset_powerUnitNumber: "Power Unit Number",
    manage_createEditAsset_decodeVIN: "Decode VIN",
    manage_createEditAsset_inspectionDeviceType: "Inspection Device Type",
    manage_createEditAsset_noInformationFoundVIN: "No information found for this VIN",
    manage_createEditAsset_maxValue: "Max value",
    manage_createEditAsset_minValue: "Min value",
    manage_createEditAsset_externalId: "External ID",
    manage_createEditAsset_createAsset: "Create New Asset",
    manage_createEditAsset_assetSaved: "Asset saved",

    manage_createEditAsset_duplicatedLabel: "Label is already in use",
    manage_createEditAsset_duplicatedlicensePlace: "License Plate is already in use",
    manage_createEditAsset_duplicatedVin: "VIN is already in use",
    manage_createEditAsset_errorVin: "Invalid VIN, must have 17 alphanumeric characters, no I, O or Q, no special characters or spaces, and with a valid check digit in the ninth position",
    manage_createEditAsset_duplicatedexternalId: "External Id is already in use",
    manage_createEditAsset_placeholderLabel: "Enter asset name or asset code",
    manage_createEditAsset_status: "Status",
    manage_createEditAsset_active: "Active",
    manage_createEditAsset_inactive: "Inactive",
    manage_createEditAsset_successMessageCreate: "Asset was created successfully",
    manage_createEditAsset_successMessageUpdate: "Asset was updated successfully",
    manage_createEditAsset_inactive: "Inactive",
    manage_createEditAsset_duplicatedTagId: "Inspection Tag ID is already in use",
    manage_createEditAsset_enterExternalId: "Enter External ID",
    manage_createEditAsset_licenseCountry: "License Country",
    manage_createEditAsset_licenseState: "License State",
    manage_createEditAsset_none: "None",
    manage_createEditAsset_requiredFields: "All required fields must be completed and contain valid values to proceed",
    manage_createEditAsset_alert_title: "Validation Error",
    manage_createEditAsset_licensePlateErrorLength: "License Plate must be between 4 and 20 characters",
}



